import * as React from 'react';
import * as styles from './OnBoarding.css';
import { IconClose16 } from '@cian/ui-kit';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function OnBoarding(_ref) {
  var onClose = _ref.onClose,
    children = _ref.children;
  return /*#__PURE__*/_jsxs("div", {
    className: styles['container'],
    children: [children, /*#__PURE__*/_jsx("div", {
      className: styles['close'],
      onClick: onClose,
      children: /*#__PURE__*/_jsx(IconClose16, {
        color: "gray60_100"
      })
    })]
  });
}